<template>
<div class="requests-table">
  <!-- BEGIN FLOAT HEAD TABLE -->
  <div class="table-toolbar">

      <button @click="download" class="btn btn-icon"><i class="fa fa-download"></i></button>
      <button @click="showColumnPicker = true" class="btn btn-icon"><i class="fa fa-columns"></i></button>

      <!-- <FormulateInput v-model="query"" type="text" placeholder="Enter a search term..." />
           <button type="submit" class="btn btn-icon"><i class="fa fa-search"></i></button> -->
  </div>
  <transition name="fade">
    <div id="wrapper" class='wrapper small'>
      <div class="table-responsive">
        <table class="table table-bordered table-hover table-striped policies-table">
          <thead>
            <tr>
              <th></th>
              <th v-for="c in pickedColumns">
                {{ c.name }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in rows" :key="row.id">
              <td class="text-center">
                <button class="btn btn-link" v-on:click="showDetails(row.id)">
                  <i class="fa fa-info" style="padding-right: 0"></i>
                </button>
              </td>
              <td v-for="field in row.fields">
                  {{ field }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="ls-table-pagination">
        <button class="btn btn-primary" :disabled="previous == 0 || loading" @click="page--"><i class="fa fa-arrow-left"></i> prev</button> | 
        <button class="btn btn-primary" :disabled="next == 0 || loading" @click="page++">next <i class="fa fa-arrow-right"></i></button>
      </div>
    </div>
  </transition>
  <!-- END ENDLESS TABLE -->
  <columns-picker-modal v-if="showColumnPicker"
                        :availableColumns="columns"
                        @close="showColumnPicker = false"
                        @setColumns="savePickedColumns">
  </columns-picker-modal>
  <epic-client-modal v-if="clientRecord"
                v-bind:client="clientRecord"
                v-on:close="clientRecord = null">
  </epic-client-modal>
  <!-- END LEAD DETAIL -->
</div>
</template>

<script>

 // http://mkoryak.github.io/floatThead/#examples

 import Vue from 'vue';
 import ColumnsPickerModal from 'components/modals/ColumnsPickerModal';
 import EpicClientModal from 'components/modals/EpicClientModal';

 export default {
     name: 'epicclientstable',
     props: {
         datesRange: Object,
         pivots: Object
     },
     components: {
         'columns-picker-modal': ColumnsPickerModal,
         'epic-client-modal': EpicClientModal
     },
     created() {
         BUS.$on('refreshTable', this.fetch, true);
     },
     data () {
         return {
             orderBy: null,
             orderAsc: false,
             page: 1,
             next: 0,
             previous: 0,
             mapping: [],
             headerLabels: [],
             rows: [],
             picked: new Set(),
             clientRecord: null,
             query: "",
             loading: false,
             showColumnPicker: false
         };
     },
     computed: {
         columns () {
             var self = this;
             var res = _.map(this.mapping, (item, index) => {
                 return {
                     slug: item,
                     name: self.headerLabels[index],
                     picked: self.picked.has(item)
                 };
             });
             return res;
         },
         pickedColumns() {
             return _.filter(this.columns, (c) => c.picked);
         }
     },
     watch: {
         datesRange: function () {
             this.fetch();
         },
         page: function () {
             this.fetch(this.page);
         },
         pivots: {
             handler: function () {
                 this.fetch();
             },
             deep: true
         }
     },
     mounted () {
         this.fetch();
     },
     methods: {
         savePickedColumns (columns) {
             var self = this;
             let picked = _.filter(columns, (c) => c.picked);
             let pickedFields = _.map(picked, (c) => c.slug);
             this.picked = new Set(pickedFields);
             API.basin.setClientsColumns(pickedFields)
                .then(() => {
                    Vue.toast(
                        'Columns saved successfully',
                        { className: ['et-info'] }
                    );
                    self.showColumnPicker = false;
                    self.fetch();
                })
                .catch(() => {
                    Vue.toast(
                        'Unexpected error',
                        { className: ['et-error'] }
                    );
                    self.showColumnPicker = false;
                });
         },
         populateRows (rowsArr) {
             var self = this;
             self.rows = [];
             rowsArr.forEach(function (row) {
                 var r = {
                     id: row.id,
                     fields: []
                 };
                 self.pickedColumns.forEach(function (c) {
                     let f = c.slug;
                     let v = row[f] || '';
                     if (f == 'timestamp') {
                         v = v ? self.$options.filters.formatTimestamp(v) : '';
                     }
                     r.fields.push(v);
                 });
                 self.rows.push(r)
             }); 
         },
         handleResponse(response) {
             var self = this;
             self.headerLabels = response.data.header['labels'];
             self.mapping = response.data.header['fields'];
             self.picked = new Set(response.data.header['picked_fields']);
             self.populateRows(response.data.results);
             var data = {
                 'pivots': response.data.pivots,
                 'stats': response.data.stats
             };
             
             if (response.data.next !== null) {
                 self.next = self.page + 1;
             }
             else {
                 self.next = 0;
             }
             
             if (response.data.previous !== null) {
                 self.previous = self.page - 1;
             }
             else {
                 self.previous = 0;
             }
             self.$emit('loaded', data);
         },
         fetchNext: _.debounce(function () {
             this.fetch(this.next);
         }),
         fetchPrev: _.debounce(function () {
             this.fetch(this.prev);
         }),
         prepareRequest: function (request) {
             if (this.query) {
                 request['q'] = this.query;
             }
             
             if (this.datesRange['from']) {
                 request['from_date'] = this.datesRange['from'];
             }
             
             if (this.datesRange['to']) {
                 request['to_date'] = this.datesRange['to'];
             }
             
             _.forOwn(this.pivots, function (v, k) {
                 if (v) {
                     request[k] = v;
                 }
             });
         },
         fetch: _.debounce(function (nextPage) {
             if (!this.loading) {
                 this.loading = true;
                 var req = {
                     page: 1
                 }
                 
                 if (typeof nextPage !== "undefined") {
                     req['page'] = nextPage;
                 }
                 this.prepareRequest(req);
                 
                 var self = this;
                 
                 API.basin.getClients(req)
                    .then(function (response) {
                        self.page = req.page;
                        self.handleResponse(response);
                        self.loading = false;
	                //self.isLoading = false;
                    }, self.onErrorCallback)
                    .catch(function (err) {
                        self.loading = false;
                    });
             }
         }, 100),
         showDetails(id) {
             var self = this;
             API.basin.getClient(id)
	        .then(function (response) {
	            self.clientRecord = response.body;
	        });
         },
         download: _.debounce(function () {
             var req= {};
             var self = this;
             
             this.prepareRequest(req);

             API.basin.downloadClients(req);

         }, 50),
     }
 };
</script>

<style lang="scss" scoped>
 .table-toolbar {
     display: flex;
     flex-direction: row;
     justify-content: start;
     
 
 .policies-table {
   border-radius: 4px;
   padding: 10px;
   
   th, .th {
       background: #f38c3d;
       color: #fff;
       vertical-align: middle;
       white-space: nowrap;
   }

   td {
     white-space: nowrap;
   }

   td>.btn {
     text-align: center;
     padding: 0px 6px;
   }

   .wrapper {
     position: relative;
   }

   .wrapper.small {
     height: 100%;
     width: 100%;
   }
   .not-visible {
     visibility: hidden;
   }
   
   tr.not-visible,
   tr.not-visible td {
     padding: 0 !important;
     height: 0 !important;
     line-height: 0 !important;
   }
   
   tr.not-visible td div {
     display: inline-block;
     white-space: nowrap;
     margin-right: 42px;
     font-weight: 500;
     font-size: 16px;
     line-height: 0;
   }
 }

 }
 /**

    .table-toolbar {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    padding: 6px 4px;
    background-color: #adadad; 
    
    form {
    > * {
    display: inline-block;
    }

    .formulate-input {
    margin-bottom: 0px;

    input {
    background: #efefef;
    width: 100%!important;

    &:focus {
    background: #fff;
    }
    }
    }
    }
    }


    table.leads-queue-table {
    font-family: 'Roboto Mono','Inconsolata', monospace;
    }
  */

 
 
</style>



// WEBPACK FOOTER //
// EpicClientsTable.vue?0a145c0d